import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <br />
      <a
        rel="noopener noreferrer"
        href="https://github.com/KasiaMenger/Cats-life-React-App"
        target="_blank"
      >
        Open-Source Code {""}
      </a>
      by
      <a
        rel="noopener noreferrer"
        href="https://www.linkedin.com/in/mengerk/"
        target="_blank"
      >
        {" "}
        Kasia Menger{" "}
      </a>
    </div>
  );
}
